import { Outlet } from "react-router-dom"

export const EditNeedsLayout = () => {
    return <Outlet />
}